import React from 'react';
import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useIsUpsellEnabled } from 'bento-ordering/cart/utils/menuUpsellSelectors';
import menuItemModule from 'bento-ordering/menus/actions/menuItem';
import { useSelectedLocationSlug } from 'bento-ordering/menus/selectors';
import { generatePath } from 'bento-ordering/utils/generatePath';
import {
  MENU,
  UPSELL_MENU_ITEM_DETAIL
} from 'bento-ordering/menus/constants/entities';
import { OO_UPSELL_HEADER_AB } from 'constants/cookies';
import {
  AB_TEST_MENU_UPSELL_HEADER,
  DEFAULT_MENU_UPSELL_HEADER
} from 'bento-ordering/cart/constants/copies';
import MenuUpsellContainer from 'base-ordering/containers/MenuUpsellContainer';
import useGetUpdatedUpsellItems from 'bento-ordering/hooks/useGetUpdatedUpsellItems';

const MenuUpsell = () => {
  const isUpsellEnabled = useIsUpsellEnabled();
  const upsellItems = useGetUpdatedUpsellItems();
  const history = useHistory();
  const dispatch = useDispatch();
  const selectedLocationSlug = useSelectedLocationSlug();
  const isUpsellHeaderABEnabled = Cookies.get(OO_UPSELL_HEADER_AB) === 'True';

  const handleOpenModal = upsellItemSlug => {
    const path = generatePath(MENU, UPSELL_MENU_ITEM_DETAIL, {
      menuItemSlug: upsellItemSlug,
      slug: selectedLocationSlug
    });
    history.push(path);
  };

  const handleQuickAddToCart = upsellItem => {
    dispatch(menuItemModule.handleQuickAddToCart(upsellItem.product.id));
  };
  const menuUpsellHeader = isUpsellHeaderABEnabled
    ? AB_TEST_MENU_UPSELL_HEADER
    : DEFAULT_MENU_UPSELL_HEADER;

  return (
    <MenuUpsellContainer
      isUpsellEnabled={isUpsellEnabled}
      upsellItems={upsellItems}
      handleOpenModal={handleOpenModal}
      handleQuickAddToCart={handleQuickAddToCart}
      menuUpsellHeader={menuUpsellHeader}
    />
  );
};

export default MenuUpsell;
